var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { updateWidgetConfigurationMutation } from '@dixa/lib-integrations-partner-widgets';
import { Avatar, Button, FlexBox, Switch, Text, Tooltip, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { analytics } from 'app/utils/segment';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { getTooltipContent } from '../../../utils/integrationTooltipContent/integrationTooltipContent';
import { getIntegration, } from '../../../utils/useIntegrations/integrations';
import styles from './integrationsCard.module.scss';
export const IntegrationsCard = ({ integrationsCard, }) => {
    const navigate = useAppNavigate();
    const notify = useNotifications();
    const { id, label, enabled, cardType, integrationType, description } = integrationsCard;
    const { icon, iconColors } = getIntegration({ id: cardType });
    const [switchState, setSwitchState] = useState(enabled);
    const [updateWidgetConfiguration] = useMutation(updateWidgetConfigurationMutation);
    const handleSwitchChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const isEnabled = event.target.checked;
        setSwitchState(isEnabled);
        const response = yield updateWidgetConfiguration({
            variables: {
                id,
                enabled: isEnabled,
                name: label,
            },
        });
        if ('errors' in response) {
            notify({
                title: 'Error',
                text: `"${label}" could not be ${isEnabled ? 'enabled' : 'disabled'}.`,
                icon: 'i-error',
                time: 5000,
            }, NotificationType.Error);
        }
        else {
            notify({
                title: 'Success',
                text: `"${label}" has been ${isEnabled ? 'enabled' : 'disabled'}.`,
                icon: 'i-done',
                time: 5000,
            }, NotificationType.Success);
        }
    });
    const handleEditClick = () => {
        if (integrationType === 'customCard') {
            const customCardType = cardType;
            analytics.settingsIntegrationsItemClicked({
                integrationsId: id,
            });
            navigate({
                path: `/settings/integrations/${customCardType}-card/edit/:id`,
                params: { path: { id } },
            });
        }
        if (integrationType === 'partnerWidget') {
            analytics.partnerIntegrationsSettingsOverviewViewed({
                widgetId: id,
                widgetType: cardType,
            });
            navigate({
                path: `/settings/integrations/partner-widget/:type/:id`,
                params: {
                    path: {
                        id,
                        type: cardType,
                    },
                },
            });
        }
    };
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "row", gap: "300", padding: "400 250", className: styles.integrationsCard }, { children: [_jsx(FlexBox, Object.assign({ padding: "0 0 0 300" }, { children: _jsx(Tooltip, Object.assign({ content: getTooltipContent({ cardType, integrationType }), dark: true }, { children: _jsx(Avatar, { size: "40", icon: icon, color: iconColors }) })) })), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300", width: "100%" }, { children: [_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: label })), _jsx(Text.Paragraph, Object.assign({ className: styles.integrationsCardDescription }, { children: description })), _jsxs(FlexBox, Object.assign({ flexDirection: "row", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }, { children: [_jsxs(FlexBox, Object.assign({ gap: "200" }, { children: [_jsx(Button, Object.assign({ icon: "pen", variant: "secondary", onClick: handleEditClick }, { children: "Edit" })), integrationType === 'customCard' && (_jsx(Button, Object.assign({ icon: "play", variant: "secondary", onClick: () => navigate({
                                            path: `/settings/integrations/${cardType}-card/test/:id`,
                                            params: { path: { id } },
                                        }) }, { children: "Test" })))] })), integrationType === 'partnerWidget' && (_jsx(Switch, { checked: switchState, name: "enabled-switch", value: "", onChange: handleSwitchChange }))] }))] }))] }), id));
};
